<app-menu-header></app-menu-header>
<div class="main-content">
  <h1>Примеры меню</h1>
  <div *ngFor="let item of items; let i = index">
    <p>Content row {{ i + 1 }}</p>
  </div>
</div>
